import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Radio,
  Select,
  Stack,
  Step,
  StepLabel,
  Stepper,
  Tooltip,
  Typography,
  useTheme,
  Zoom,
} from '@mui/material';

import AssignDriver from '../assign-driver';
import OrderExpense from '../../expenses/order-expense';
import LegCharge from '../../driver-charges/driver-charge';
import InputField from 'components/Input-Field/input-field';
import NextStatusModal from '../next-status';
import { formatAppointment, formatCurrency, formatAddress } from 'utils/formatter.js';
import { AggregateLegCharges, AggregateCompanyShareExpenses, AggregateDriverBasePayForOrder, AggregateOrderExpenses, calculateOrderTotal } from 'utils/calculations.js';
import { LEG_TYPE_MAPPING } from 'utils/constant.js';
import * as IntermodalOrderAction from 'actions/order-action';
import * as OTROrderAction from 'actions/otr/otr-order-action';

import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';

import CTTabs from 'components/CTTabs';
import DataDialog from 'components/dialogs/DataDialog';

import * as OTROrderService from 'services/otr/otr-order-service';
import * as IntermodalOrderService from 'services/order-service';

import { tokens } from 'theme/tokens';
import StatusPill from 'components/StatusPill';
import CTMap from 'components/CTMap';
import FTIcons from 'assets/icons/FTIcons';
import LabelValueBox from 'components/LabelValueBox';
import ReactCardFlip from 'react-card-flip';
import CTStepper from 'components/CTStepper';
import { FormattedData } from 'styles/GlobalStyle';
import LoadDocumentManager from 'components/LoadDocumentManager';
import { getOrderNotifications } from 'services/notification-service';
import InvoiceModal from 'containers/Accounting/invoice-modal';
import OTRTruck from '../forms/subforms/otr-truck';
import { color } from 'framer-motion';
import { variants } from 'tailwind.config';
import ContentDrawer from 'components/ContentDrawer';

const RATE_TYPES = {
  'CPM': 'CPM',
  'FLAT': 'FLAT',
  'FIXED RATE': 'FIXED',
  'LOAD PERCENT': 'PERCENTAGE',
  'PER HOUR': 'HOURLY'
};
const LoadDetail = (props) => {
  const LOAD_DATA_TABS = ['Summary', 'Documents', 'Activity', 'Invoice'];
  const ORDER_PAYMENT_STATUS = ['UNPAID', 'INVOICED', 'RECEIVED'];
  const INTERMODAL_DRIVER_SECTION = ['Driver', 'Charges'];
  const OTR_DRIVER_SECTION = ['Driver', 'Charges', 'Truck'];

  const { order, transportationMode, drivers, isProcessing, toast } = props;
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [expense, setExpense] = useState({
    id: '',
    category: '',
    categoryDescription: '',
    name: '',
    billableAmount: '',
    companyShare: '',
    driverShare: '',
    isPerDay: false,
    expenseType: 'BILLABLE',
  });

  const [legCharge, setLegCharge] = useState({
    id: '',
    category: '',
    categoryDescription: '',
    name: '',
    amount: '',
    status: 'NEW',
  });

  const [yard_address, setYardAddress] = useState({
    street: '',
    city: '',
    state: '',
    zipcode: '',
    country: '',
  });

  const [truckForm, setTruckForm] = useState({
    equipmentId: null,
    equipmentType: '',
    equipmentConfiguration: null,
    truckId: null,
    truck: '',
    startMileage: '',
    endMileage: '',
    trailerNumber: '',
    trailerLicense: '',
    trailerNumberHook: '',
    trailerLicenseHook: '',
    weightUnit: 'lbs',
    lengthUnit: 'feet',
  });

  const [driverRateModel, setDriverRateModel] = useState({
    id: '',
    driverRate: '',
    rateType: '',
    miles: '',
    hours: '',
  });
  const [selectedLegTabIndex, setSelectedLegTabIndex] = useState(0);
  const [selectedDataTabIndex, setSelectedDataTabIndex] = useState(0);
  const [isEdit, setIsEdit] = useState(false);
  const [orderExpenses, setOrderExpenses] = useState(null);
  const [expenseFormAction, setExpenseFormAction] = useState('Save');
  const [legChargeFormAction, setLegChargeFormAction] = useState('Save');
  const [destinationStatus, setDestinationStatus] = useState(null);
  const [nextStatusActions, setNextStatusActions] = useState(null);
  const [isNextStatusModalOpen, setIsNextStatusModalOpen] = useState(false);
  const [isAssignDriverModalOpen, setIsAssignDriverModalOpen] = useState(false);
  const [isLegChargeDialogOpen, setIsLegChargeDialogOpen] = useState(false);
  const [isEditDriverRate, setIsEditDriverRate] = useState(false);
  const [isExpenseDialogOpen, setIsExpenseDialogOpen] = useState(false);
  const [isDriverSMSModelOpen, setIsDriverSMSModelOpen] = useState(false);
  const [isEditOriginDialog, setIsEditOriginDialog] = useState(false);
  const [isEditDestinationDialog, setIsEditDestinationDialog] = useState(false);
  const [isEditChassisDialog, setIsEditChassisDialog] = useState(false);
  const [isEditContainerDialog, setIsEditContainerDialog] = useState(false);
  const [isEditOrderSummary, setIsEditOrderSummary] = useState(false);
  const [isMapComponentDialogOpen, setIsMapComponentDialogOpen] = useState(false);
  const [gotNextStatus, setGotNextStatus] = useState(false);
  const [isContainerLoading, setIsContainerLoading] = useState(false);
  const [isChassisLoading, setIsChassisLoading] = useState(false);
  const [isOriginLoading, setIsOriginLoading] = useState(false);
  const [isDestinationLoading, setIsDestinationLoading] = useState(false);
  const [isAssignDriverLoading, setIsAssignDriverLoading] = useState(false);
  const [anchorElement, setAnchorElement] = useState(null);
  const [anchorMenuElement, setAnchorMenuElement] = useState(null);
  const [documentList, setDocumentList] = useState([]);
  const [orderActivity, setOrderActivity] = useState([]);
  const [invoice, setInvoicePreview] = useState(null);
  const [driverSectionTabIndex, setDriverSectionTabIndex] = useState(0);
  const [selectedDriver, setSelectedDriver] = useState(null);
  // Tracking
  const [isProcessingTrackingUpdate, setIsProcessingTrackingUpdate] = useState(false);
  const [trackingStages, setTrackingStages] = useState([]);

  const [currentLeg, setCurrentLeg] = useState(null);
  const [currentLegId, setCurrentLegId] = useState(null);

  // componentDidMount equivalent
  useEffect(() => {
    if (order) {
      const orderId = order.id;
      const legs = order.legs;
      const leg = legs && legs.length !== 0 ? legs[0] : null;
      const legId = leg && leg.id;

      setIsProcessingTrackingUpdate(true);
      setSelectedLegTabIndex(0);
      setCurrentLeg(leg);
      setCurrentLegId(legId);
      const orderService = transportationMode === 'OTR' ? OTROrderService : IntermodalOrderService;
      orderService.getOrderTimingStats(orderId).then((res) => {
        const stages = res?.data?.filter((d) => d.legId === legId && d.otr === false) || [];
        setIsProcessingTrackingUpdate(false);
        setTrackingStages(stages);
      });
    }
  }, [order]); // empty deps = only run once on mount

  const RenderedMap = ({ leg }) => {
    const map = useMemo(() => {
      const distance = `${leg.distance} ${leg.distanceUnit}`;
      const duration = leg.duration;
      const location1 = leg.origins
        ?.filter(loc => loc?.address?.geo)
        .map(loc => [loc.address.geo.lat, loc.address.geo.lng]) || [];

      const location2 = leg.destinations
        ?.filter(loc => loc?.address?.geo)
        .map(loc => [loc.address.geo.lat, loc.address.geo.lng]) || [];

      return (
        <Box width={'auto'} height={350} m={.5} p={.5}>
          {distance && duration ? <Box
            sx={{
              background: colors.base.white,
              position: 'absolute',
              zIndex: 15000,
            }}
          >
            <Typography variant='body1'>Distance: {distance}</Typography>
            <Typography variant='body1'>Duration: {duration}</Typography>
          </Box> : null
          }
          <CTMap
            key={leg.id}
            zoom={7}
            location1={location1}
            location2={location2}
            origins={leg.origins}
            destinations={leg.destinations}
          />
        </Box>
      );
    }, [currentLeg]);
    return map;
  };

  const handleClick = (event) => {
    setAnchorMenuElement(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorMenuElement(null);
  };

  const handlePopoverToggle = useCallback((evt) => {
    setAnchorElement((prev) => (prev ? null : evt.currentTarget));
  }, []);

  const changeLegTab = (evt, tabIndex) => {
    setIsProcessingTrackingUpdate(true);
    const tab = evt.currentTarget.textContent;
    if (tab) {
      const tabName = tab.split(' ').length > 0 ? tab.split(' ')[0] : 'None';
      const legId = tab.split(' ').length > 0 ? parseInt(tab.split(' ')[1]) : 0;
      const currentLeg = order.legs.filter(leg => leg.id === legId)[0];
      const orderId = order.id;
      setSelectedLegTabIndex(tabIndex);
      setCurrentLegId(parseInt(legId));
      setCurrentLeg(currentLeg);
      const orderService = transportationMode === 'OTR' ? OTROrderService : IntermodalOrderService;
      orderService.getOrderTimingStats(orderId).then(res => {
        const stages = res && res.data ? res.data.filter(d => d.legId === legId && d.otr === false) : [];
        setIsProcessingTrackingUpdate(false);
        setTrackingStages(stages);
      });
    }
  };

  const closeAssignDriverDialog = () => {
    props.resetState('RESET_TOAST_STATE');
    setIsAssignDriverModalOpen(false);
    setSelectedDriver(null);
  };

  const toggleExpenseDialog = () => {
    const expense = {
      id: '',
      name: '',
      category: '',
      categoryDescription: '',
      billableAmount: '',
      companyShare: '',
      driverShare: '',
      isPerDay: false,
      expenseType: 'BILLABLE',
    };
    props.resetState('RESET_TOAST_STATE');
    setExpenseFormAction('Save');
    setExpense(expense);
    setIsExpenseDialogOpen((prev) => !prev);
  };

  const showOrderNetCalculations = (order) => {
    const billableExpense = AggregateCompanyShareExpenses(order.expenses);
    let totalDriverPayForOrder = 0;
    let totalLegCharges = 0;
    order.legs.forEach(leg => {
      totalLegCharges += AggregateLegCharges(leg.legCharges);
      totalDriverPayForOrder += AggregateDriverBasePayForOrder(leg);
    });
    const result = <div style={{ padding: '4px' }}>
      <p>Order Rate <span >{formatCurrency(order.orderRate)}</span></p>
      <p>FSC <span>{formatCurrency(order.fuelCharges)}</span></p>
      <p>Expenses(Profit) <span>{formatCurrency(billableExpense)}</span></p>
      <p>Total DriverPay <span>{formatCurrency(totalDriverPayForOrder)}</span></p>
      <p>Driver Chagres <span>{formatCurrency(totalLegCharges)}</span></p>
    </div>;
    return result;
  };

  const deleteOrderLeg = (leg) => {
    const legId = Number(leg.title.split(':')[1].trim());
    if (window.confirm('This will delete current leg. Are you sure you want to delete LegId ? ', legId)) {
      if (window.confirm('Deleting leg is permanent action. Press OK to proceed.')) {
        props.deleteOrderLeg(legId);
      }
    }
  };

  const handleDriverAssignment = (leg, selectedDrivers) => {
    // Assign new driver or change existing driver.
    props.assignDriver(leg.id, selectedDrivers)
  };

  const handleEditDriver = (driver) => {
    setSelectedDriver(driver);
    setIsAssignDriverModalOpen(true);
  }

  const updateSelectedDriver = (leg, selectedDriver) => {
    const driverEntry = selectedDriver[0];
    props.changeDriver(leg.id, driverEntry);
    setSelectedDriver(null);
  };

  const unassignDriver = (legId, driverId) => {
    if (window.confirm('Do you want to un-assign the driver ?')) {
      props.unassignDriver(legId, driverId);
    }
  };

  const changeDriverAvailability = (driver) => {
    changeDriverAvailability(driver.id).then(() => {
      const availableDrivers = drivers.map(drvr => {
        if (drvr.id === driver.id) {
          drvr = { ...driver, available: true };
        }
        return drvr;
      });
      setDriver(availableDrivers);
    });
  };

  const toggleNextStatusDialog = useCallback((leg) => {
    setIsNextStatusModalOpen((prev) => !prev);
    setNextStatusActions(leg.nextStatusActions);
  }, []);

  const updateNextStatus = (action, leg, address) => {
    const orderId = order.id;
    const timestamp = new Date().toISOString();
    props.setNextStatusForOrder(orderId, leg, timestamp, action, address);
    setIsNextStatusModalOpen(false);
    setGotNextStatus(false);
  };

  const getLocationStatusColor = (value) => {
    return value ? theme.status.location[value.toLowerCase()] : theme.status.location.default;
  };

  /** Driver Rate */
  const handleDriverRateChange = (evt) => {
    const rateObject = { ...driverRateModel };
    rateObject[evt.target.name] = evt.target.name === 'rateType' ? evt.target.value : Number(evt.target.value);
    setDriverRateModel(rateObject);
  };

  const toggleEditDriverRate = (driver) => {
    if (driver) {
      const rateModel = {
        id: driver.id,
        driverRate: driver.rate,
        rateType: driver.rateType || 'FIXED',
        miles: driver.miles,
        hours: driver.hours
      };
      setDriverRateModel(rateModel);
    }
    setIsEditDriverRate((prev) => !prev);
  };

  const updateDriverRate = (legId, input) => {
    props.updateDriverRate(legId, input);
    setIsEditDriverRate((prev) => !prev);
  };

  /** Driver Charges */
  const toggleLegChargesDialog = () => {
    const legCharge = {
      id: '',
      name: '',
      category: '',
      categoryDescription: '',
      amount: 0,
      status: 'NEW',
    };
    setLegChargeFormAction('Save');
    setLegCharge(legCharge);
    setIsLegChargeDialogOpen((prev) => !prev);
  };
  const editLegCharge = (legCharge) => {
    setLegCharge(legCharge);
    setLegChargeFormAction('Update');
  };

  const saveLegCharge = (charges) => {
    transportationMode === 'OTR' ? props.saveCharge(currentLegId, selectedDriver.id, charges) : props.saveCharge(currentLegId, charges);
    setSelectedDriver(null);
  };

  const updateLegCharge = (charges) => {
    transportationMode === 'OTR' ? props.updateCharge(currentLegId, selectedDriver.id, charges) : props.updateCharge(currentLegId, charges);
    setSelectedDriver(null);
  };

  const deleteLegCharge = (legCharge) => {
    props.deleteCharge(currentLegId, legCharge.id);
    setSelectedDriver(null);
  };

  //TODO: Change to Action instead
  /** Expenses */
  const saveOrderExpense = (orderExpense) => {
    const orderId = order.id;
    props.saveExpense(orderId, orderExpense);
  };

  const editOrderExpense = (orderExpense) => {
    setExpense(orderExpense);
    setExpenseFormAction('Update');
  };

  const updateOrderExpense = (orderExpense) => {
    const orderId = order.id;
    props.updateExpense(orderId, orderExpense);
  };

  const deleteOrderExpense = (orderExpense) => {
    const orderId = order.id;
    props.deleteExpense(orderId, orderExpense.id);
  };

  /* Order Tracking */
  const renderTrackingSection = (order, leg) => {
    return (
      <Box>
        {isProcessingTrackingUpdate && <CircularProgress />}
        <CTStepper stages={trackingStages} />
      </Box>
    );
  };

  /* Status Section */
  const renderStatusSection = (order, leg) => {
    return (
      <ReactCardFlip
        isFlipped={isNextStatusModalOpen}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            height: '60px',
            py: 1.5,
            px: 2,
            border: `1px solid ${colors.neutral[200]}`,
            borderRadius: '6px',
            textAlign: 'center',
            gap: 1.5,
          }}
        >
          <Stack>
            <StatusPill
              status={leg.status}
              label={leg.status}
              size='large'
            />
            <Typography variant='caption'>Current Status</Typography>
          </Stack>
          <Box
            display={'flex'}
            gap={1}
          >
            <Button
              variant='contained'
              startIcon={
                <FTIcons.CogIcon
                  width={'24px'}
                  height={'24px'}
                  fill={'#fff'}
                />
              }
              sx={{
                height: 32,
              }}
              color='primary'
              disabled={!leg.drivers || leg.drivers.length == 0 || leg.status === 'COMPLETE' || leg.status === 'COMPLETED'}
              onClick={() => toggleNextStatusDialog(leg)}
            >
              Change Status
            </Button>
            {/* <Button
            variant='outlined'
            startIcon={
              <FTIcons.LocationIcon
                width={'24px'}
                height={'24px'}
                fill={colors.secondary.main}
              />
            }
            sx={{
              height: 32,
              background: colors.secondary.soft,
              border: `1px solid ${colors.secondary.light}`,
              color: colors.secondary.main
            }}
            disabled={!leg.driver || leg.status === 'COMPLETE' || leg.status === 'COMPLETED'}
          >
            Live Tracking
          </Button> */}
          </Box>
        </Box>
        <NextStatusModal
          orderId={order.id}
          leg={leg}
          yard_address={yard_address}
          actions={nextStatusActions || []}
          fnOnNextStatusClick={(status, address) => updateNextStatus(status, leg, address)}
          handleClose={() => setIsNextStatusModalOpen(false)}
        />
      </ReactCardFlip>
    );
  };

  /* Driver Section */
  const renderDriverSection = (order, leg) => {
    const assignedDrivers = leg.drivers || [];
    const driverHTMLElement = assignedDrivers.map((driver, idx) => {
      let avatarText = 'N.A';
      if (driver.fullName) {
        let fullName = driver.fullName.split(' ');
        avatarText = fullName.length < 2 ? `${fullName[0][0]}${fullName[0][1]}` : `${fullName[0][0]}${fullName[1][0]}`;
      }
      const driverRate = driver ? driver.rate : 0;
      return (
        <Stack key={`${driver.id}-${idx}`} direction={'row'} spacing={1} width={'100%'} padding={1}>
          <Avatar
            sx={{
              width: 32,
              height: 32,
              fontSize: 16,
              fontWeight: 500,
              color: colors.primary.main,
              bgcolor: colors.primary.soft
            }}>{avatarText}</Avatar>
          <LabelValueBox value={driver.fullName} label='Name' />
          <LabelValueBox value={driver.phone} label='Phone' />
          <LabelValueBox
            value={formatCurrency(driverRate, 'USD', 'standard')}
            label={`Rate (${driver.rateType || 'FIXED'})`}
            action={<IconButton size='small' disabled={leg.drivers.length === 0} onClick={() => toggleEditDriverRate(driver)}>
              <FTIcons.EditIcon
                width={16}
                height={16}
                fill={leg.drivers.length !== 0 ? colors.primary.dark : colors.primary.light} />
            </IconButton>}
          />
          {driver.rateType === 'CPM' && <LabelValueBox value={driver.miles} label='Miles' />}
          {driver.rateType === 'HOURLY' && <LabelValueBox value={driver.hours} label='Hours' />}
          <IconButton
            size='small'
            onClick={() => unassignDriver(leg.id, driver.id)}>
            <FTIcons.RemoveIcon
              width={20}
              height={20}
              fill={colors.error.dark}
            />
          </IconButton>
        </Stack>
      );
    });
    return <Box>
      <ReactCardFlip
        isFlipped={isEditDriverRate}
      >
        <Box>
          {driverHTMLElement}
        </Box>
        <Grid container spacing={1} mt={1} p={1}>
          <Grid size={{ xs: 12, sm: 4 }}>
            <FormControl fullWidth>
              <InputLabel id='payment-label'>Select Rate Type</InputLabel>
              <Select
                labelId='payment-label'
                name={'rateType'}
                value={driverRateModel.rateType}
                onChange={(evt) => handleDriverRateChange(evt)}
                margin='dense'
                size='small'
                fullWidth
              >
                {Object.entries(RATE_TYPES).map(([key, value]) => (
                  <MenuItem key={key} value={value}>{key}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 4, sm: 4 }}>
            <InputField
              autoFocus
              type='number'
              label='Enter Rate'
              name={'driverRate'}
              onChange={(evt) => handleDriverRateChange(evt)}
              value={driverRateModel.driverRate}
              isFullWidth={true}
              valid />
          </Grid>
          <Grid size={{ xs: 4, sm: 4 }}>
            <InputField
              autoFocus
              type='number'
              label='Enter Total Miles'
              name='miles'
              onChange={(evt) => handleDriverRateChange(evt)}
              value={driverRateModel.miles}
              isFullWidth={true}
              disabled={driverRateModel.rateType !== 'CPM'}
              valid />
          </Grid>
          <Grid size={{ xs: 4, sm: 3 }}>
            {driverRateModel.rateType === 'HOURLY' && <InputField
              autoFocus
              type='number'
              label='Enter Driver Hours'
              name={'hours'}
              onChange={(evt) => handleDriverRateChange(evt)}
              value={driverRateModel.hours}
              isFullWidth={true}
              valid />
            }
          </Grid>
          <Grid size={{ xs: 12 }}>
            {driverRateModel.rateType === 'CPM' && <Typography variant='body1' fontWeight={500} sx={{ color: colors.neutral[500] }}>{`Total Pay: ${Number(driverRateModel.driverRate * driverRateModel.miles).toFixed(2)} `}</Typography>}
            {driverRateModel.rateType === 'HOURLY' && <Typography variant='body1' fontWeight={500} sx={{ color: colors.neutral[500] }}>{`Total Pay: ${Number(driverRateModel.driverRate * driverRateModel.hours).toFixed(2)} `}</Typography>}
          </Grid>
          <Box display={'flex'} justifyContent={'flex-end'}>
            <Button
              aria-label='edit'
              onClick={() => updateDriverRate(leg.id, driverRateModel)}
              size='small'
              variant='outlined'
              color={colors.primary.light}
              startIcon={
                <FTIcons.CheckboxIcon
                  width={20}
                  height={20}
                  fill={colors.success.main}
                />
              }
            >Update Rate
            </Button>
            <Button
              aria-label='cancel'
              onClick={() => toggleEditDriverRate()}
              size='small'
              variant='outlined'
              color={colors.error.main}
              startIcon={<FTIcons.MinusIcon
                width={20}
                height={20}
                fill={colors.error.main}
              />
              }
            >Cancel
            </Button>
          </Box>
        </Grid>
      </ReactCardFlip>
      <ContentDrawer
        open={isAssignDriverModalOpen}
        title={'Assign Driver'}
        width={'md'}
        isProcessing={isProcessing}
        toast={toast}
        handleClose={closeAssignDriverDialog}
      >
        {selectedDriver ?
          <AssignDriver
            legDistance={leg.distance}
            isOTR={transportationMode === 'OTR'}
            isIndividualDriver={true}
            drivers={drivers}
            assignedDrivers={[selectedDriver]}
            fnOnAssignDriverHandler={(selectedDrivers) => updateSelectedDriver(leg, selectedDrivers)}
            fnOnChangeDriverAvailabilityHandler={changeDriverAvailability}
          /> :
          <AssignDriver
            legDistance={leg.distance}
            isOTR={transportationMode === 'OTR'}
            isIndividualDriver={assignedDrivers.length < 2}
            drivers={drivers}
            assignedDrivers={assignedDrivers}
            fnOnAssignDriverHandler={(selectedDrivers) => handleDriverAssignment(leg, selectedDrivers)}
            fnOnChangeDriverAvailabilityHandler={changeDriverAvailability}
          />
        }
      </ContentDrawer>
      {assignedDrivers.length === 0 && <Box textAlign={'center'}>
        <IconButton
          onClick={() => setIsAssignDriverModalOpen(true)}
        >
          <AddCircleOutlineOutlinedIcon color='primary' />
        </IconButton> Assign Driver
      </Box>
      }
    </Box>
  };

  /* Leg Charge */
  const renderLegChargeSection = (order, leg) => {
    let legCharges = [];
    const assignedDrivers = leg.drivers || [];
    if (assignedDrivers.length === 0) {
      return <Typography color={colors.neutral[400]} variant='body1' fontWeight={600} textAlign={'center'} textTransform={'uppercase'}>No Driver Assigned. Assign Driver To Add Charges</Typography>
    } else {
      const chargesElement = assignedDrivers.map((driver, idx) => {
        let avatarText = 'N.A';
        if (driver.fullName) {
          let fullName = driver.fullName.split(' ');
          avatarText = fullName.length < 2 ? `${fullName[0][0]}${fullName[0][1]}` : `${fullName[0][0]}${fullName[1][0]}`;
        }

        legCharges = transportationMode === 'OTR' ? leg.legCharges.filter(lc => lc.driver.id == driver.id) : leg.legCharges;
        return (<Stack key={`${driver.id}-${idx}`} direction={'row'} spacing={1} width={'100%'} padding={1}>
          <Avatar
            sx={{
              width: 32,
              height: 32,
              fontSize: 16,
              fontWeight: 500,
              color: colors.primary.main,
              bgcolor: colors.primary.soft
            }}>{avatarText}</Avatar>
          <LabelValueBox value={driver.fullName} label='Name' />
          <LabelValueBox value={driver.phone} label='Phone' />
          <LabelValueBox
            value={formatCurrency(AggregateLegCharges(legCharges), 'USD', 'standard')}
            label='Charges'
            action={<IconButton size='small' onClick={() => { setSelectedDriver(driver); toggleLegChargesDialog(); }}>
              <FTIcons.PlusIcon
                width={20}
                height={20}
                fill={leg.drivers && leg.drivers.length !== 0 ? colors.primary.dark : colors.primary.light} />
            </IconButton>}
          />
        </Stack>)
      });
      return <Box>
        {chargesElement}
        {selectedDriver && <DataDialog
          open={isLegChargeDialogOpen}
          title={'Driver Charges'}
          width={'md'}
          isProcessing={isProcessing}
          toast={toast}
          onCloseHandler={() => toggleLegChargesDialog()}
        >
          <Box
            m='10px 0 0 0'
          >
            <LegCharge
              action={legChargeFormAction}
              legCharge={legCharge}
              legChargeList={legCharges}
              fnOnSaveHandler={saveLegCharge}
              fnOnEditHandler={editLegCharge}
              fnOnUpdateHandler={updateLegCharge}
              fnOnDeleteHandler={deleteLegCharge}
            />
          </Box>
        </DataDialog>}
      </Box>
    }
  };
  /* Origin & Destination */
  const renderLocations = (order, leg) => {
    const origins = leg.origins.map((origin, idx) => {
      const color = getLocationStatusColor(origin.status);
      const appointment = formatAppointment(origin.appointment);
      return (
        <Box key={`o-${origin.id}`} px={1.5}>
          <Stack direction='row' justifyContent='space-between'>
            <Box mt={'5px'} mr={'10px'}>
              <FTIcons.CircleIcon
                width={'10px'}
                height={'10px'}
                fill={colors.primary.main}
              />
            </Box>
            <LabelValueBox
              value={origin.name}
              label={formatAddress(origin.address)}
              valueVariant='subtitle2'
              valueFontWeight={600}
              labelVariant='body1'
            />
            <Box>
              <StatusPill
                status={origin.status}
                label={origin.status || 'New'}
                size={'large'}
              />
            </Box>
          </Stack>
          <Stack direction={'row'} sx={{ marginLeft: '20px' }}>
            <LabelValueBox
              value={origin.puNumber || 'N.A'}
              label={'PU Number'}
            />
            <LabelValueBox
              value={origin.puLocation || 'N.A'}
              label={'PU Location'}
            />
            <LabelValueBox
              value={appointment && appointment.substring(0, 10)}
              label={appointment && appointment.substring(11)}
              valueVariant='subtitle2'
              labelVariant='body1'
              valueFontWeight={600}
              labelFontWeight={600}
            />
          </Stack>
          <Stack direction={'row'} sx={{ marginLeft: '20px' }}>
            <LabelValueBox
              value={origin.requiresAppointment || 'Yes'}
              label={'Open Appointment'}
            />
            <LabelValueBox
              value={origin.notes}
              label={'Notes'}
            />
          </Stack>
        </Box>
      );
    });
    const destinations = leg.destinations.map((destination, idx) => {
      const color = getLocationStatusColor(destination.status);
      const appointment = formatAppointment(destination.appointment);
      return (
        <Box key={`o-${origin.id}`} px={1.5}>
          <Stack direction='row' justifyContent='space-between'>
            <Box mt={'5px'} mr={'10px'}>
              <FTIcons.LocationIcon
                width={'15px'}
                height={'15px'}
                fill={colors.secondary.main}
              />
            </Box>
            <LabelValueBox
              value={destination.name}
              label={formatAddress(destination.address)}
              valueVariant='subtitle2'
              valueFontWeight={600}
              labelVariant='body1'
            />
            <Box>
              <StatusPill
                status={destination.status}
                label={destination.status || 'New'}
                size={'large'}
              />
            </Box>
          </Stack>
          <Stack direction={'row'} sx={{ marginLeft: '20px' }}>
            <Box></Box>
            <LabelValueBox
              value={destination.referenceNumber || destination.deliveryNumber}
              label={'Delivery Number'}
            />
            <LabelValueBox
              value={origin.puLocation}
              label={'PU Location'}
            />
            <LabelValueBox
              value={appointment && appointment.substring(0, 10)}
              label={appointment && appointment.substring(11)}
              valueVariant='subtitle2'
              labelVariant='body1'
              valueFontWeight={600}
              labelFontWeight={600}
            />
          </Stack>
          <Stack direction={'row'} sx={{ marginLeft: '20px' }}>
            <LabelValueBox
              value={destination.requiresAppointment || 'Yes'}
              label={'Open Appointment'}
            />
            <LabelValueBox
              value={destination.notes}
              label={'Notes'}
            />
          </Stack>
        </Box>
      );
    });

    return (
      <Box
        sx={{
          height: 'auto',
          py: 1.5,
          border: `1px solid ${colors.neutral[200]}`,
          borderRadius: '6px',
        }}
        gap={2}
      >
        {origins}
        &nbsp;
        {destinations}
        <Box
          sx={{
            mt: 2,
            pt: 1,
            px: 2,
            borderTop: `1px solid ${colors.neutral[200]}`,
          }}
        >
          <Typography variant='body1' color={colors.neutral[700]}>Order Notes</Typography>
          <Box
            sx={{
              py: 1,
              px: 1.5,
              minHeight: '52px',
              border: `1px solid ${colors.blue[200]}`,
              borderRadius: '4px',
              background: colors.main_blue[50]
            }}
          >
            <Typography variant='caption'>{order.notes}</Typography>
          </Box>
        </Box>
      </Box>
    );
  };

  /* Render Truck */
  const renderTruckSection = (order, leg) => {
    const { loadType, weight, length, truck, startMileage, endMileage, trailerNumber, trailerLicense, trailerNumberHook, trailerLicenseHook } = order;
    return (
      <Box>
        <ReactCardFlip
          // isFlipped={isTruckAssigned}
          flipDirection='horizontal'
        >
          {/* FRONT */}
          <Box>
            {truck ?
              <Stack direction={'row'} spacing={1} width={'100%'} padding={'8px 16px'}>
                <LabelValueBox value={truck.truckNumber} label='Truck Number' />
                <LabelValueBox value={truck.truckType} label='Truck Type' />
                <LabelValueBox value={truck.licensePlate} label='Truck License' />
                <LabelValueBox value={trailerNumber || 'None'} label='Trailer Number' />
              </Stack> :
              <Stack direction={'row'} spacing={1} width={'100%'} padding={'0px 16px'}>
                <Typography variant='subtitle2' color={colors.error.main} margin={'auto'}>No Truck Assigned.</Typography>
              </Stack>
            }
            {/* <Stack direction={'row'} spacing={1} width={'100%'} padding={'8px 16px'}>
              <LabelValueBox value={trailerNumber || 'None'} label='Trailer Number' />
              <LabelValueBox value={trailerLicense || 'None'} label='Trailer License' />
              {loadType === 'DROP_AND_HOOK' && <LabelValueBox value={trailerNumberHook || 'None'} label='Trailer Number Hook' />}
              {loadType === 'DROP_AND_HOOK' && <LabelValueBox value={trailerLicenseHook || 'None'} label='Trailer License Hook' />}
            </Stack> */}
          </Box>
          <Box>
          </Box>
        </ReactCardFlip>
      </Box>
    );
  };

  /* Render Container & Chassis */
  const renderContainerSection = (container, chassis, loadType) => {
    const containerNumber = loadType === 'DELIVERY' ? container.deliveryContainerNumber : container.pickupContainerNumber;
    return (
      <Grid container spacing={1}>
        <Grid size={{ xs: 4 }}>
          {containerNumber ?
            <Typography
              gutterBottom
              variant='body1'
              sx={{ color: colors.neutral[800] }}
            >{containerNumber}
            </Typography> : <Typography
              gutterBottom
              variant='body1'
              sx={{ color: colors.error.main }}
            >{'None'}
            </Typography>
          }
          <Typography
            variant='body2'
            sx={{ color: colors.neutral[500] }}
          >
            {'Container Number'}
          </Typography>
        </Grid>
        <Grid size={{ xs: 3 }}>
          <Typography
            gutterBottom
            variant='body1'
            sx={{ color: colors.neutral[800] }}
          >
            {container && container.lastFreeDate || 'N.A.'}
          </Typography>
          <Typography
            variant='body2'
            color={colors.neutral[500]}
          >
            {'LFD'}
          </Typography>
        </Grid>
        <Grid size={{ xs: 3 }}>
          <Typography
            gutterBottom
            variant='body1'
            sx={{ color: colors.neutral[800] }}
          >
            {container && container.line}
          </Typography>
          <Typography
            variant='body2'
            color={colors.neutral[500]}
          >
            {'Line'}
          </Typography>
        </Grid>
        <Grid size={{ xs: 2 }}>
          <Typography
            gutterBottom
            variant='body1'
            sx={{ color: colors.neutral[800] }}
          >
            {container && container.status}
          </Typography>
        </Grid>

        <Grid size={{ xs: 4 }}>
          {chassis && chassis.chassisNumber ?
            <Typography
              gutterBottom
              variant='body1'
              sx={{ color: colors.neutral[800] }}
            >
              {chassis && chassis.chassisNumber}
            </Typography> :
            <Typography
              gutterBottom
              variant='body1'
              sx={{ color: colors.error.main }}
            >{'None'}
            </Typography>
          }
          <Typography
            variant='body2'
            color={colors.neutral[500]}
          >
            {'Chassis Number'}
          </Typography>
        </Grid>
        <Grid size={{ xs: 4 }}>
          <Typography
            gutterBottom
            variant='body1'
            sx={{ color: colors.neutral[800] }}
          >
            {chassis && chassis.company || 'None'}
          </Typography>
          <Typography
            variant='body2'
            color={colors.neutral[500]}
          >
            {'Company'}
          </Typography>
        </Grid>

        <Grid size={{ xs: 12 }}>
          <Typography
            gutterBottom
            variant='body1'
            sx={{ color: colors.neutral[800] }}
          >
            {container && container.dropLocation}
          </Typography>
          <Typography
            variant='body2'
            color={colors.neutral[500]}
          >
            {'Drop Location'}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const handleTablePanelChange = (tab) => {
    if (tab === 1) { // Documents
      IntermodalOrderService.getFilesByOrderId(order.id, transportationMode === 'OTR')
        .then((res) => {
          if (res.status === 200 && res.data) {
            setDocumentList(res.data);
          }
        })
        .catch((e) => {
          setDocumentList([]);
        })
        .finally(() => {
          setSelectedDataTabIndex(tab);
        })
    } else if (tab === 2) { // Activity
      getOrderNotifications(order.id, transportationMode === 'OTR')
        .then((res) => {
          setOrderActivity(res.data);
        })
        .finally(() => {
          setSelectedDataTabIndex(tab);
        });
    } else if (tab === 3) {
      const orderService = transportationMode === 'OTR' ? OTROrderService : IntermodalOrderService;
      orderService.getInvoiceByOrderId(order.id)
        .then((res) => {
          setInvoicePreview(res.data);
        })
        .catch((e) => {
          setInvoicePreview(null);
        })
        .finally(() => {
          setSelectedDataTabIndex(tab);
        })
    } else { // Summary
      setSelectedDataTabIndex(tab);
    }
  };
  /* Order Information in different tabs. */
  const SummaryPanel = (order, leg) => {
    const { broker, brokerOrderNumber, palletQty, temperature, tempUnit, fuelCharges, fuelChargesType, expenses, container, chassis } = order;
    const orderRate = transportationMode === 'INTERMODAL' ? order.orderRate : order.lineHaulCharges;
    const brokerName = broker ? broker.name : '-';
    const address = broker && broker.address ? `${broker.address.city} ${broker.address.state} ${broker.address.country}` : '-';
    const expensePopoverInformation = expenses.map((exp, idx) => (<Stack key={`exp-${idx}`}>
      <Box display={'flex'} gap={1}>
        <Typography variant='body1'>{exp.name}</Typography>
        <Typography variant='body1'>{formatCurrency(exp.billableAmount, 'en-US', 'standard')}</Typography>
      </Box>
    </Stack>
    ));
    return (
      <Stack spacing={1} alignItems={'stretch'}>
        <Stack spacing={0.5}>
          <Box display={'flex'} justifyContent={'space-between'}>
            <Typography variant='body2' sx={{ color: colors.neutral[500] }}>Broker</Typography>
            <Stack>
              <Typography variant='body1' sx={{ color: colors.neutral[800] }}>{brokerName}</Typography>
              <Typography variant='body1' sx={{ color: colors.neutral[500] }}>{address}</Typography>
            </Stack>
          </Box>
          <Box display={'flex'} justifyContent={'space-between'}>
            <Typography variant='body2' sx={{ color: colors.neutral[500] }}>Broker Load Number</Typography>
            <Typography variant='body1' sx={{ color: colors.neutral[800] }}>{brokerOrderNumber}</Typography>
          </Box>
          <Box display={'flex'} justifyContent={'space-between'}>
            <Typography variant='body2' sx={{ color: colors.neutral[500] }}>Pallet Qty.</Typography>
            <Typography variant='body1' sx={{ color: colors.neutral[800] }}>{palletQty || 0}</Typography>
          </Box>
          <Box display={'flex'} justifyContent={'space-between'}>
            <Typography variant='body2' sx={{ color: colors.neutral[500] }}>Temperature</Typography>
            <Typography variant='body1' sx={{ color: colors.neutral[800] }}>{`${temperature || '34'} ${tempUnit || 'F'}`}</Typography>
          </Box>
        </Stack>
        <Divider />
        <Box>
          <Box display={'flex'} justifyContent={'space-between'}>
            <Typography variant='subtitle2' fontWeight={600} color={colors.neutral[900]}>{'Payment'}</Typography>
            <Button
              size='small'
              variant='text'
              color={colors.primary.main}
              startIcon={<FTIcons.PlusIcon
                width={24}
                height={24}
                fill={colors.primary.main} />
              }
              onClick={toggleExpenseDialog}
            >
              Add Expense
            </Button>
          </Box>
          <Box display={'flex'} justifyContent={'space-between'}>
            <Typography variant='body2' sx={{ color: colors.neutral[500] }}>Order Rate</Typography>
            <Typography variant='body1' sx={{ color: colors.neutral[800] }}>{formatCurrency(orderRate)}</Typography>
          </Box>
          <Box display={'flex'} justifyContent={'space-between'}>
            <Typography variant='body2' sx={{ color: colors.neutral[500] }}>FSC</Typography>
            <Typography variant='body1' sx={{ color: colors.neutral[800] }}>{fuelCharges}</Typography>
          </Box>
          <Box display={'flex'} justifyContent={'space-between'}>
            <Typography variant='body2' sx={{ color: colors.neutral[500] }}>Expenses</Typography>
            <Typography variant='body1' sx={{ color: colors.neutral[800] }} onClick={() => toggleExpensePopover(order)}>
              <Tooltip
                TransitionComponent={Zoom}
                placement='bottom'
                title={expensePopoverInformation} arrow>
                <FormattedData variant='body1'
                  sx={{ fontWeight: 500, fontSmooth: 'auto' }}>
                  {formatCurrency(AggregateOrderExpenses(expenses))}
                </FormattedData>
              </Tooltip>
            </Typography>
          </Box>
          <Box display={'flex'} justifyContent={'space-between'} mt={1}>
            <Typography variant='subtitle2' color={colors.neutral[800]}>Total</Typography>
            <Typography variant='subtitle2' fontWeight={500} color={colors.neutral[800]}>{formatCurrency(calculateOrderTotal(orderRate, fuelCharges, fuelChargesType, expenses))}</Typography>
          </Box>
        </Box>
        <Divider />
        <Typography variant='subtitle2' fontWeight={600} color={colors.neutral[900]}>{'Truck or Container'}</Typography>
        {transportationMode === 'OTR' && renderTruckSection(order, leg)}
        {container && renderContainerSection(container, chassis)}
        <DataDialog
          open={isExpenseDialogOpen}
          title={'Expense'}
          width={'md'}
          isProcessing={isProcessing}
          toast={toast}
          onCloseHandler={() => toggleExpenseDialog()}
        >
          <OrderExpense
            action={expenseFormAction}
            expense={expense}
            expenseList={order.expenses || []}
            fnOnSaveHandler={saveOrderExpense}
            fnOnUpdateHandler={updateOrderExpense}
            fnOnEditHandler={editOrderExpense}
            fnOnDeleteHandler={deleteOrderExpense}
          />
        </DataDialog>
      </Stack>
    );
  };

  const DocumentPanel = (order, leg) => {
    return (
      <LoadDocumentManager
        orderId={order.id}
        documentList={documentList}
        isOTR={transportationMode === 'OTR'}
      />
    );
  };

  const ActivityPanel = (order, leg) => {
    return <Stack
      spacing={1}
      divider={<Divider flexItem />}
    >
      {orderActivity.map(activity => (
        <LabelValueBox value={activity.message} label={formatAppointment(activity.timestamp)} />
      ))}
    </Stack>
  };

  const InvoicePanel = (order, leg) => {
    const isInvoiceCreated = Boolean(['DELIVERED', 'TERMINAL', 'COMPLETE', 'COMPLETED'].filter(status => status === order.status).length);
    return isInvoiceCreated ? <InvoiceModal invoice={invoice || null} /> : <Box>
      <Typography variant='subtitle1' fontWeight={500} sx={{ color: colors.base.black }}>
        {`Order is in ${order.status}`}
      </Typography>
      <Typography variant='subtitle2' fontWeight={500} sx={{ color: colors.neutral[400] }}>
        {'Please complete the order to create an invoice automatically.'}
      </Typography>
    </Box>
  };
  /**
     * Order is a complex entity and detail view needs to display all the
     * required and related information for an order.
     *
     * Following is the render order
     * 1. Render Status and Net $amount (profit and loss)
     * 2. Render Summary mostly read only data
     * 3. A order can have 1 or more legs. Each leg is rendered as a tab
     * 4. A Leg tab shows Status, Driver and Equipment information (same across order)
     * 5. A leg tab will also render Origin (Shipper) and Destination
     * 6. Each leg also render equipment status.
     */
  if (order && order.legs) {
    const legs = order.legs;
    const legTabs = legs.map(leg => { return LEG_TYPE_MAPPING[leg.legType] ? `${LEG_TYPE_MAPPING[leg.legType]} ${leg.id}` : leg.id });
    return (
      <React.Fragment>
        {/* Topbar */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            height: '40px',
            py: 1,
            px: 2,
            border: `1px solid ${colors.neutral[200]}`,
            borderRadius: '6px',
            textAlign: 'center',
          }}
        >
          <Typography
            variant='subtitle2'
            style={{ fontWeight: 600, color: colors.base.black }}
          >
            {transportationMode === 'INTERMODAL' ? order.displayOrderId : order.loadId} &nbsp;&nbsp;
            {/* <FTIcons.EditIcon width={20} height={20} fill={colors.primary.main} /> */}
          </Typography>
          <Stepper activeStep={ORDER_PAYMENT_STATUS.findIndex(e => e === order.paymentStatus)}>
            {ORDER_PAYMENT_STATUS.map(st => (
              <Step key={st}>
                <StepLabel>{st}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>

        {/* Leg Tabs Container */}
        <Box>
          <CTTabs
            labels={legTabs}
            tabIndex={selectedLegTabIndex}
            addNewButtonEnabled={false}
            removeButtonEnabled={false}
            fnOnRemoveTabHandler={tab => deleteOrderLeg(tab)}
            fnOnTabChangeHandler={(tab, evt) => changeLegTab(evt, tab)}
          />
          {legs.map(leg => {
            return leg.id === currentLegId ?
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={1}
                alignItems={'stretch'}
              >
                {/* Main Container */}
                <Stack
                  key={`key:leg:${leg.id}`}
                  spacing={1}
                  width={'100%'}
                >
                  {renderTrackingSection(order, leg)}
                  {renderStatusSection(order, leg)}
                  <Box
                    sx={{
                      height: 'auto',
                      pb: 2,
                      border: `1px solid ${colors.neutral[200]}`,
                      borderRadius: '6px',
                      gap: 2,
                    }}
                  >
                    <Box
                      display={'flex'}
                      justifyContent={'space-between'}
                    >
                      <CTTabs
                        labels={transportationMode === 'OTR' ? OTR_DRIVER_SECTION : INTERMODAL_DRIVER_SECTION}
                        tabIndex={driverSectionTabIndex}
                        fnOnTabChangeHandler={(index, evt) => setDriverSectionTabIndex(index)}
                      />
                      {driverSectionTabIndex === 0 && leg.drivers && leg.drivers.length > 0 ?
                        <Box>
                          <IconButton
                            onClick={() => setIsAssignDriverModalOpen(true)}>
                            <FTIcons.PlusIcon
                              width={20}
                              height={20}
                              fill={selectedDriver ? colors.primary.dark : colors.primary.light}
                            />
                          </IconButton>
                        </Box> : <Box></Box>
                      }
                    </Box>
                    {driverSectionTabIndex === 0 && renderDriverSection(order, leg)}
                    {driverSectionTabIndex === 1 && renderLegChargeSection(order, leg)}
                    {driverSectionTabIndex === 2 && renderTruckSection(order, leg)}
                  </Box>
                  {renderLocations(order, leg)}
                </Stack>
                {/*Side Container */}
                <Stack spacing={1} sx={{ width: { xs: '100%', md: '418px' }, flexShrink: 0 }}>
                  {/* Map Container */}
                  {<RenderedMap
                    leg={leg}
                  />
                  }
                  {/* Load Information Panel */}
                  <Stack>
                    <CTTabs
                      labels={LOAD_DATA_TABS}
                      tabIndex={selectedDataTabIndex}
                      fnOnTabChangeHandler={(tab, evt) => handleTablePanelChange(tab)}
                    />
                    <Box
                      sx={{
                        height: 'auto',
                        border: `1px solid ${colors.neutral[200]}`,
                        borderRadius: '6px',
                        py: 1,
                        px: 2,
                        gap: 1.5,
                      }}
                    >
                      {selectedDataTabIndex === 0 && SummaryPanel(order, leg)}
                      {selectedDataTabIndex === 1 && DocumentPanel(order, leg)}
                      {selectedDataTabIndex === 2 && ActivityPanel(order, leg)}
                      {selectedDataTabIndex === 3 && InvoicePanel(order, leg)}
                    </Box>
                  </Stack>
                </Stack>
              </Stack> : <React.Fragment />
          }
          )}
        </Box>
      </React.Fragment>
    );
  }
}

function mapDispatchToProps(dispatch, ownProps) {
  return ownProps && ownProps.transportationMode === 'OTR' ? bindActionCreators(OTROrderAction, dispatch) : bindActionCreators(IntermodalOrderAction, dispatch);
}

function mapStateToProps(state, ownProps) {
  const { order, toast, isProcessing } = ownProps && ownProps.transportationMode === 'OTR' ? state.otrOrderReducer : state.orderReducer;
  const { drivers } = state.driverReducer;
  return {
    order: order,
    drivers,
    toast,
    isProcessing,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoadDetail);